export const MOBILE_NAV_HEIGHT = '48px'
export const MOBILE_CONTENT_GAP = '24px'
export const PWA_SAFE_BOTTOM = 'max(env(safe-area-inset-bottom, 0px), 20px)'

/** Только нижнее меню PWA — меньше min, чем у контента */
export const PWA_NAV_SAFE_BOTTOM = 'max(env(safe-area-inset-bottom, 0px), 12px)'

export const mobileBottomInsetBrowser =
  `${MOBILE_NAV_HEIGHT} + ${MOBILE_CONTENT_GAP}`

export const mobileBottomInsetPwa =
  `${MOBILE_NAV_HEIGHT} + ${PWA_NAV_SAFE_BOTTOM} + ${MOBILE_CONTENT_GAP}`

export const MOBILE_FIXED_BOTTOM_BASE = 50

export function mobileFixedBottom(basePx = MOBILE_FIXED_BOTTOM_BASE): string {
  return `calc(${basePx}px + ${PWA_SAFE_BOTTOM})`
}

export const commentsButtonPwaSx = {
  bottom: mobileFixedBottom(),
} as const
